import { render, staticRenderFns } from "./fruit.vue?vue&type=template&id=2fca4432&scoped=true&"
import script from "./fruit.vue?vue&type=script&lang=js&"
export * from "./fruit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fca4432",
  null
  
)

export default component.exports